import * as APIBase from './APIBase';

export default class VehicleCapableApi {
  static get() {
    return APIBase.getVehicleData();
    // return APIBase.getAPI(process.env.REACT_APP_IDP_VEHICLE_CAPABILITIES_API+'/vehicle_capabilities',false);
  }
}
